import { useRuntimeConfig } from "#imports";

function getPublicConfig() {
  return useRuntimeConfig().public;
}

export function getHeaders() {
  return {
    "Content-Type": "application/json",
    Accept: "application/json",
  };
}

export const getAssets = async () => {
  try {
    const { NUXT_PUBLIC_ASSETS } = getPublicConfig();
    const response = await fetch(`${NUXT_PUBLIC_ASSETS}/assets`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const result = await response.json();
    localStorage.setItem("assets", JSON.stringify(result.data));
    return result.data;
  } catch (error) {
    console.error("Fetch error:", error);
    throw error;
  }
};

export const lotsizeCalculate = async (market, data) => {
  try {
    const { NUXT_PUBLIC_CALCULATORS } = getPublicConfig();
    const response = await fetch(`${NUXT_PUBLIC_CALCULATORS}/${market}`, {
      method: "POST",
      headers: getHeaders(),
      body: JSON.stringify(data),
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.message || "Something went wrong");
    }

    const result = await response.json();
    console.log(result, "result");
    return result;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const fibonacciCalculate = async (data) => {
  try {
    const { NUXT_PUBLIC_CALCULATORS } = getPublicConfig();
    const response = await fetch(`${NUXT_PUBLIC_CALCULATORS}/fibonacci`, {
      method: "POST",
      headers: getHeaders(),
      body: JSON.stringify(data),
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.message || "Something went wrong");
    }

    const result = await response.json();
    console.log(result, "result");
    return result;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const masterCalculate = async (market, body) => {
  try {
    const { NUXT_PUBLIC_CALCULATORS } = getPublicConfig();
    const response = await fetch(`${NUXT_PUBLIC_CALCULATORS}/${market}`, {
      method: "POST",
      headers: getHeaders(),
      body: JSON.stringify(body),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const result = await response.json();
    console.log(result);
    return result;
  } catch (error) {
    console.error("Fetch error:", error);
    throw error;
  }
};
export const convertCurrencyCalculate = async (body) => {
  try {
    const { NUXT_PUBLIC_CALCULATORS } = getPublicConfig();
    const response = await fetch(`${NUXT_PUBLIC_CALCULATORS}/convert`, {
      method: "POST",
      headers: getHeaders(),
      body: JSON.stringify(body),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const result = await response.json();
    return result;
  } catch (error) {
    console.error("Fetch error:", error);
    throw error;
  }
};
export const pivotCalculate = async (pivot, data) => {
  let body = data;
  if (pivot === "pivotpoint") {
    body = {
      high: data.highest_price,
      low: data.lowest_price,
      close: data.closing_price,
    };
  }

  try {
    const { NUXT_PUBLIC_CALCULATORS } = getPublicConfig();
    const response = await fetch(`${NUXT_PUBLIC_CALCULATORS}/${pivot}`, {
      method: "POST",
      headers: getHeaders(),
      body: JSON.stringify(body),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const result = await response.json();
    console.log(result);
    return result;
  } catch (error) {
    console.error("Fetch error:", error);
    throw error;
  }
};
